module.exports = __webpack_public_path__ + "img/img_service_02.341e6c56.png";